import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FdmPrecheckWizardOverlayComponent } from './fdm-precheck-wizard-overlay.component';

@NgModule({
  imports: [CommonModule],
  declarations: [FdmPrecheckWizardOverlayComponent],
  exports: [FdmPrecheckWizardOverlayComponent]
})
export class FdmPrecheckWizardModule {}
